import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiConfig } from "./api/config.api";

@Injectable({
  providedIn: "root",
})
export class HttpService {
  constructor(private http: HttpClient) {}

  getHeaders(credentials) {
    const authUrl = "api/authentication";
    let data =
      "j_username=" +
      encodeURIComponent(credentials.username) +
      "&j_password=" +
      encodeURIComponent(credentials.password) +
      "&submit=Login";
    return this.http.post(ApiConfig.baseURL + authUrl, data, {
      headers: ApiConfig.requestOptionsHeaderForLogin,
    });
  }

  generateXclientToken() {
    const tokenUrl =
      "/api/eazypension-auth-service/v1/token/generateXClient?language=en_us&channel=mobile";
    const fullUrl =
      "https://eazypension-uat.dev.azlife.allianz.co.id/sit/api/eazypension-auth-service/v1/token/generateXClient?language=en_us&channel=mobile";
    return this.http.post(ApiConfig.baseURL + tokenUrl, "");
  }
}
